const getters = {
  user_privacy:state=>state.User.user_privacy,
  person_msg:state=>state.User.person_msg,
}
export default getters
